"use client";

import { useEffect } from "react";
import { useAppearanceStore } from "@/store/appearance.store";

export function ThemeApplier() {
  const { mode } = useAppearanceStore();

  useEffect(() => {
    const html = document.documentElement;
    if (mode === "dark") {
      html.classList.add("dark");
    } else {
      html.classList.remove("dark");
    }
  }, [mode]);

  return null;
}
